export default __webpack_public_path__ + "static/media/user-icon.a692f9a5.svg";